import angular from 'angular';
import rbResizeWatcher from './rb-resize-watcher/rb-resize-watcher.dir';
import rbSorted from './rb-sorted/rb-sorted.dir';

export default angular.module('rb.directives', [])
  .directive('rbResizeWatcher', rbResizeWatcher)
  .directive('rbSorted', rbSorted);
